import { Timestamp } from 'firebase/firestore';
import { IArtisanProject } from '@core/interfaces/IArtisanProject';
import { IDocumentDataArtisanProject } from '../interfaces/IDocumentDataArtisanProject';
import { IForm } from '../interfaces/Form';

export const transformDataToArtisanProject = ({
    creationDate,
    lastUpdateDate,
    ...rest
}: IDocumentDataArtisanProject): IArtisanProject => ({
    ...rest,
    ...(creationDate && { creationDate: new Date(creationDate.toDate()) }),
    ...(lastUpdateDate && { lastUpdateDate: new Date(lastUpdateDate.toDate()) }),
});

export const transformArtisanProjectToData = ({
    creationDate,
    lastUpdateDate,
    ...rest
}:IArtisanProject):IDocumentDataArtisanProject => ({
    ...rest,
    ...(creationDate && {
        creationDate: Timestamp.fromDate(new Date(creationDate)),
    }),
    ...(lastUpdateDate && {
        lastUpdateDate: Timestamp.fromDate(new Date(lastUpdateDate)),
    }),
});

export const removePortfolioImagesURLs = (artisanProjectSource: Partial<IForm>): Partial<IForm> => {
    const artisanProject = JSON.parse(JSON.stringify(artisanProjectSource)) as Partial<IForm>;
    const portfolioImages = artisanProject?.fields?.portfolioData?.images.value?.map(({ id }) => ({ id }));

    if (portfolioImages) {
        // @ts-ignore
        artisanProject.fields.portfolioData.images.value = portfolioImages;
    }

    return artisanProject;
};

export const moveLocationToProject = (artisanProjectSource: Partial<IForm>): Partial<IForm> => {
    const artisanProject = JSON.parse(JSON.stringify(artisanProjectSource)) as Partial<IForm>;
    const portfolioPlace = artisanProject?.fields?.portfolioData?.place;

    if (portfolioPlace && portfolioPlace.location?.geometry) {
        const { value, location } = portfolioPlace;

        artisanProject.location = {
            formatted: value,
            ...location,
        };

        delete portfolioPlace.location;
    }

    return artisanProject;
};
